// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ASYjA","right":"styles_right__2EA-N"};